import type { GeoJsonData } from '../../../../app-kit/components/PcaMap/PcaMap';
import { fitBoundsToGeoJson } from '../../../../app-kit/components/PcaMap/helpers/fitBoundsToGeoJson';

export const fitPropertyMapByBounds = (
  map: google.maps.Map,
  propertyBoundary?: GeoJsonData | null,
  buildingBoundaries?: GeoJsonData | null,
) => {
  if (propertyBoundary) {
    fitBoundsToGeoJson({ map, geoJsonData: propertyBoundary });
  } else if (buildingBoundaries) {
    fitBoundsToGeoJson({ map, geoJsonData: buildingBoundaries });
  }
};
